<template>
	<div>
		<div v-if="hasDeleteBtn">
			<div class="linkcontent" v-for="(item, index) in value" :key="index" @click="linkClick(item, index)">
				<img class="link-img" :src="require('../../../../assets/appraise/ic_lj@2x.png')" />
				<div class="content-c">{{ `链接${index + 1}` }}</div>
				<img class="delete-img" :src="require('../../../../assets/appraise/deletematerial.png')" @click="deleteLink(index)" />
			</div>
		</div>
		<div v-else>
			<div class="linkcontent-link" v-for="(item, index) in value" :key="index" @click="linkClick(item, index)">
				<div class="linkcontent-name">{{ `链接${index + 1}` }}</div>
				<img class="link-img-tip" :src="require('../../../../assets/appraise/ic_lj@2x.png')" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "linkCom",
	props: {
		value: {
			type: Array,
			default: () => []
		},
		hasDeleteBtn: {
			type: Boolean,
			default: () => true
		},
	},
	data() {
		return {};
	},
	methods: {
		linkClick(item, index) {
            window.yyn.invokeJSB("openWindow", {
                    openUrl: item.caseUrl,
                    isFullScreen: 0,
                    setTitle: `链接${Number(index) + 1}`,
                    needLoading: 1
                },
                cb => {
                    console.log(item, "callback");
                }
            );
		},
		deleteLink(index) {
			this.value.splice(index, 1);
			this.$emit("input", this.value);
		},
	},
};
</script>
<style lang="less" scoped>
.linkcontent {
	width: 100%;
	display: flex;
	justify-content: space-between;
	height: 38px;
	align-items: center;
	background: rgba(255, 255, 255, 1);
	border-radius: 3px;
	border: 1px solid rgba(237, 237, 237, 1);
	margin-bottom: 8px;
	.link-img {
		width: 14px;
		height: 14px;
		margin-left: 9px;
	}
	.content-c {
		width: 100%;
		margin-left: 9px;
	}
	.delete-img {
		width: 15px;
		height: 16px;
		margin-right: 12px;
	}
}
.linkcontent-link {
	width: 100%;
	height: 38px;
	background: rgba(255, 255, 255, 1);
	border-radius: 3px;
	border: 1px solid rgba(237, 237, 237, 1);
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
	.linkcontent-name {
		width: 100%;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		margin-left: 8px;
	}
	.link-img-tip {
		width: 14px;
		height: 14px;
		margin-right: 9px;
	}
}
</style>
